export function decodeBase64OrReturn(value: string | null | undefined): string {
  if (!value || value.trim() === '') return '';
  try {
    return isBase64(value) ? atob(value) : value;
  } catch {
    return value;
  }
}

export function isBase64(value: string): boolean {
  if (!value || value.trim() === '') return false;
  try {
    const base64Regex = /^[A-Za-z0-9+/]*={0,2}$/;
    if (!base64Regex.test(value)) return false;
    return btoa(atob(value)) === value;
  } catch {
    return false;
  }
}

export function toBase64(value: string): string {
  return btoa(value ?? '');
}




